import { render, staticRenderFns } from "./partnerPaymentInfoByTenant.vue?vue&type=template&id=55d82649&scoped=true"
import script from "./partnerPaymentInfoByTenant.vue?vue&type=script&lang=js"
export * from "./partnerPaymentInfoByTenant.vue?vue&type=script&lang=js"
import style0 from "./partnerPaymentInfoByTenant.vue?vue&type=style&index=0&id=55d82649&prod&scoped=true&lang=css"
import style1 from "./partnerPaymentInfoByTenant.vue?vue&type=style&index=1&id=55d82649&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d82649",
  null
  
)

export default component.exports